import { render, staticRenderFns } from "./RevokeUserModal.vue?vue&type=template&id=ab857958&"
import script from "./RevokeUserModal.vue?vue&type=script&lang=js&"
export * from "./RevokeUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab857958')) {
      api.createRecord('ab857958', component.options)
    } else {
      api.reload('ab857958', component.options)
    }
    module.hot.accept("./RevokeUserModal.vue?vue&type=template&id=ab857958&", function () {
      api.rerender('ab857958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Databases/RevokeUserModal.vue"
export default component.exports